export class Person
{
	personId: number;
	personDate: Date;
}
